/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskInternalServerError
 */
export interface ExecRiskInternalServerError {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskInternalServerError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskInternalServerError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskInternalServerError
     */
    message: string;
}

/**
 * Check if a given object implements the ExecRiskInternalServerError interface.
 */
export function instanceOfExecRiskInternalServerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ExecRiskInternalServerErrorFromJSON(json: any): ExecRiskInternalServerError {
    return ExecRiskInternalServerErrorFromJSONTyped(json, false);
}

export function ExecRiskInternalServerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskInternalServerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function ExecRiskInternalServerErrorToJSON(value?: ExecRiskInternalServerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

